export const ReturnUrlHelper = {
  NAME: 'returnUrl',

  getUrl(): string | null {
    if (localStorage) {
      return localStorage.getItem(ReturnUrlHelper.NAME)
    }

    return null
  },

  setUrl(url: string): void {
    localStorage && localStorage.setItem(ReturnUrlHelper.NAME, url)
  },

  delete(): void {
    localStorage && localStorage.removeItem(ReturnUrlHelper.NAME)
  },

  go(): void {
    const url = this.getUrl()

    if (url !== null) {
      window.location.href = url
      ReturnUrlHelper.delete()
    } else {
      throw new Error('Return Url doesn`t exists')
    }
  },

}
